
import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
          observer.unobserve(el);
        }
      },
      { threshold: 0.12 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="section-reveal relative pt-36 pb-20 px-6 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b3841eb9cf80818f33f4fa0b20a9b02c.jpg"
          alt="Aerial view of farmland at sunrise"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-950/75 via-emerald-900/60 to-stone-50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <span className="inline-block text-emerald-300 font-bold text-xs tracking-widest uppercase mb-4">
          Knowledge Base
        </span>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-wide">
          Frequently Asked Questions
        </h1>
        <p className="text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed font-light">
          Straight answers to the questions farmers and landowners ask us most — organized by topic so you can find exactly what you need.
        </p>
      </div>
    </section>
  );
}
